import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useState } from 'react';
import { OptionCodeSnippet } from '../constants';
import CodeCurl from './code/curl';
import CodeOpenAI from './code/openAI';
import CodeLangchain from './code/langchain';
import { useGetLLMApiKeys } from '@/service/llm/api-key/hook';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import { models } from '@/constants/llm';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

const CodeSnippet = () => {
  const { workspaceId } = useParamWorkspaceId();
  const options = Object.values(OptionCodeSnippet);
  const [option, setOption] = useState<OptionCodeSnippet>(
    OptionCodeSnippet.cURL
  );
  const modelsOptions = models.map((model) => ({
    label: model.modelName,
    value: model.id,
  }));
  const [model, setModel] = useState<string>(models[0].id);
  const { data } = useGetLLMApiKeys(
    { workspace_id: workspaceId },
    { staleTime: 1000 * 60 * 5 }
  );
  const apiKey = data?.[0]?.api_key || '<your API key>';
  return (
    <>
      <div>
        <div className="mt-4 flex flex-col gap-4">
          {/* model */}
          <Select onValueChange={(e) => setModel(e)} value={model}>
            <SelectTrigger className="w-[200px]">
              <SelectValue placeholder="Model" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                {modelsOptions.map((option) => (
                  <SelectItem value={option.value}>{option.label}</SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
          {/* option */}
          <Tabs
            value={option}
            onValueChange={(e) => setOption(e as OptionCodeSnippet)}
            className="w-full"
          >
            <TabsList>
              {options.map((tab) => (
                <TabsTrigger key={tab} value={tab}>
                  {tab}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        </div>
        <div className="mt-6">
          {option === OptionCodeSnippet.cURL && (
            <CodeCurl model={model} apiKey={apiKey} />
          )}
          {option === OptionCodeSnippet.OpenAI && (
            <CodeOpenAI model={model} apiKey={apiKey} />
          )}
          {option === OptionCodeSnippet.Langchain && (
            <CodeLangchain model={model} apiKey={apiKey} />
          )}
        </div>
      </div>
    </>
  );
};
export default CodeSnippet;
